module.exports = __webpack_public_path__ + "static/media/coffee_featured.7754ac29.jpg";